export default "__VITE_ASSET__D2MEE6VN__"